import { useState } from 'react';

const projects = [
  {
    image: 'https://public.readdy.ai/ai/img_res/edited_a98a54f4e5cd5f2b1352f0c7a8e4ae1a_3b29224a.jpg',
    title: 'Residential Garden Oasis',
    category: 'Residential',
  },
  {
    image: 'https://public.readdy.ai/ai/img_res/822099d5078d277cd76f86fd84c52eff.jpg',
    title: 'Commercial Property Upgrade',
    category: 'Commercial',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=professional%20irrigation%20sprinkler%20system%20installation%20in%20green%20lawn%20with%20water%20spraying%20efficient%20water%20distribution%20with%20clean%20simple%20background%20showing%20modern%20irrigation%20technology&width=600&height=700&seq=port3&orientation=portrait',
    title: 'Smart Irrigation Installation',
    category: 'Irrigation',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=elegant%20stone%20patio%20hardscape%20with%20pavers%20outdoor%20seating%20area%20surrounded%20by%20landscaping%20and%20greenery%20with%20clean%20simple%20background%20showing%20quality%20hardscape%20construction&width=600&height=600&seq=port4&orientation=squarish',
    title: 'Patio & Hardscape Design',
    category: 'Residential',
  },
  {
    image: 'https://public.readdy.ai/ai/img_res/edited_9d715f5e889fb000c6835773f37e632a_c1823504.jpg',
    title: 'Front Yard Transformation',
    category: 'Residential',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=commercial%20office%20building%20landscape%20with%20manicured%20lawn%20decorative%20trees%20and%20professional%20maintenance%20business%20property%20with%20clean%20simple%20background%20showing%20commercial%20landscape%20design&width=600&height=800&seq=port6&orientation=portrait',
    title: 'Office Complex Landscaping',
    category: 'Commercial',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=drip%20irrigation%20system%20in%20garden%20bed%20with%20plants%20and%20mulch%20efficient%20watering%20solution%20with%20clean%20simple%20background%20showing%20water%20conservation%20irrigation%20method&width=600&height=600&seq=port7&orientation=squarish',
    title: 'Drip Irrigation System',
    category: 'Irrigation',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=backyard%20outdoor%20living%20space%20with%20stone%20patio%20fire%20pit%20and%20surrounding%20landscape%20with%20lush%20greenery%20with%20clean%20simple%20background%20showing%20complete%20outdoor%20entertainment%20area&width=600&height=700&seq=port8&orientation=portrait',
    title: 'Outdoor Living Space',
    category: 'Residential',
  },
];

const categories = ['All Projects', 'Residential', 'Commercial', 'Irrigation'];

export default function PortfolioGallery() {
  const [activeCategory, setActiveCategory] = useState('All Projects');
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const filteredProjects =
    activeCategory === 'All Projects'
      ? projects
      : projects.filter((project) => project.category === activeCategory);

  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-12">
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 lg:mb-0">
            Our Work Speaks<br />for Itself
          </h2>
          <div className="flex flex-wrap gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-2 font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category
                    ? 'text-emerald-600 border-b-2 border-emerald-600'
                    : 'text-gray-600 hover:text-emerald-600'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredProjects.map((project, index) => (
            <div
              key={index}
              className="relative rounded-2xl overflow-hidden group cursor-pointer"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="w-full h-80">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div
                className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-300 ${
                  hoveredIndex === index ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="text-sm text-emerald-400 mb-2">{project.category}</div>
                  <h3 className="text-xl font-bold">{project.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
